import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "UiHorizontalScroll horizontal-scroll" }

import { ref, onMounted, nextTick } from "vue";

import useHorizontalScroll from "@/use/useHorizontalScroll";
import UiIcon from "./UiIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiHorizontalScroll',
  setup(__props) {

const scrollerRef = ref<HTMLDivElement>();
const wrapperRef = ref<HTMLDivElement>();
const isCustomScrolling = ref(false);
const canScrollLeft = ref(false);
const canScrollRight = ref(false);

function scrollTo(getScrollPosition: (offset: number) => number) {
  const scrollElement = scrollerRef.value;

  if (!scrollElement) return;

  useHorizontalScroll({
    scrollElement,
    getScrollPosition,
    onScrollToRightBorder: () => (canScrollRight.value = false),
    onScrollEnd: () => (isCustomScrolling.value = false),
    onScrollStart: () => (isCustomScrolling.value = true),
    initialScrollWidth: scrollElement?.firstElementChild?.scrollWidth || 0,
    scrollAnimationDuration: 400,
  });
}

function getScrollToLeft(offset: number): number {
  const scrollElement = wrapperRef.value;

  if (!scrollElement) return 0;

  const containerWidth = scrollElement.offsetWidth;
  const index = Array.from(scrollElement.children).findIndex(
    (el) =>
      (el as HTMLElement).offsetLeft +
        (el as HTMLElement).offsetWidth +
        parseInt(window.getComputedStyle(el as HTMLElement).marginRight) -
        offset >=
      0
  );

  if (index === -1) return offset;
  if (index === 0) return 0;

  const element = scrollElement.children[index] as HTMLElement;

  const scrollTo = element.offsetLeft - (containerWidth - element.offsetWidth);

  if (scrollTo <= 32) {
    return 0;
  }

  return scrollTo;
}

function getScrollToRight(offset: number): number {
  const scrollElement = wrapperRef.value;

  if (!scrollElement) return 0;

  const containerWidth = scrollElement.offsetWidth;
  const slide = Array.prototype.find.call(
    scrollElement.children,
    (el: HTMLElement) =>
      el.offsetLeft + el.offsetWidth - offset > containerWidth
  ) as HTMLElement;

  if (!slide) {
    return offset;
  }

  return slide.offsetLeft;
}

function onscroll() {
  if (scrollerRef.value && !isCustomScrolling.value) {
    const scrollElement = scrollerRef.value;

    canScrollLeft.value = scrollElement.scrollLeft > 0;
    canScrollRight.value =
      scrollElement.scrollLeft + scrollElement.offsetWidth <
      scrollElement.scrollWidth - 16;
  }
}

onMounted(() => nextTick(onscroll));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (canScrollLeft.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo(getScrollToLeft))),
          class: "horizontal-scroll__arrow horizontal-scroll__arrow-left"
        }, [
          _createVNode(UiIcon, {
            type: "solid",
            icon: "ArrowSmLeft"
          })
        ]))
      : _createCommentVNode("", true),
    (canScrollRight.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollTo(getScrollToRight))),
          class: "horizontal-scroll__arrow horizontal-scroll__arrow-right"
        }, [
          _createVNode(UiIcon, {
            type: "solid",
            icon: "ArrowSmRight"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "scrollerRef",
      ref: scrollerRef,
      onScroll: onscroll,
      class: "horizontal-scroll__in"
    }, [
      _createElementVNode("div", {
        ref_key: "wrapperRef",
        ref: wrapperRef,
        class: "horizontal-scroll__in-wrapper"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 544)
  ]))
}
}

})